// src/components/layout/AppLayout.tsx

import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Navbar from './Navbar';
import Footer from './Footer';
import { useAppSelector, useAppDispatch } from '../../hooks/redux';
import { setDisputasAbiertas } from '../../store/slices/disputasSlice';
import { getDisputaStats } from '../../api/disputaApi';

export default function AppLayout() {
  const [collapsed,   setCollapsed]   = useState(false);
  const [mobileOpen,  setMobileOpen]  = useState(false);
  const dispatch = useAppDispatch();

  const retirosPendientes = useAppSelector((s) =>
    s.retiros.items.filter((r) => r.estado === 'PENDIENTE').length,
  );
  const disputasAbiertas = useAppSelector((s) => s.disputas.disputasAbiertas);

  // Poll disputa badge cada 60s
  useEffect(() => {
    const load = async () => {
      try {
        const stats = await getDisputaStats();
        dispatch(setDisputasAbiertas(stats.abiertas));
      } catch { /* ignore */ }
    };
    load();
    const interval = setInterval(load, 60_000);
    return () => clearInterval(interval);
  }, [dispatch]);

  return (
    <div className="app-layout">
      <Sidebar
        collapsed={collapsed}
        mobileOpen={mobileOpen}
        onToggle={() => setCollapsed((c) => !c)}
        onMobileClose={() => setMobileOpen(false)}
        retirosPendientes={retirosPendientes}
        disputasAbiertas={disputasAbiertas}
      />
      <div className={`app-main ${collapsed ? 'sidebar-collapsed' : ''}`}>
        <Navbar collapsed={collapsed} onMobileToggle={() => setMobileOpen((o) => !o)} />
        <main className="app-content">
          <Outlet />
        </main>
        <Footer />
      </div>
    </div>
  );
}
